<div class="career-banner">
  <img src="assets/images/carrer-banner.jpg" alt="carrer banner">
</div>
<section class="section about-bookwellness about-career">
  <div class="container">
    <div class="sec-head">
      <h2>Career <small> Be part of something bigger</small> </h2>
      <p>MyLifeWell is an innovative tech start-up focused on making wellness more
        accessible to the world. Our team is close-knit, though it spans the world. If that sounds like your
        ideal workplace, please email us today at <a href="mailto:careers@mylifewell.com"> careers@mylifewell.com.</a>
      </p>
    </div>
  </div>
</section>
<section class="fearless-explorers">
  <h2 class="text-center">We Are Looking For Wellness Trailblazers</h2>
  <div class="container">

    <div class="application-form">
      <div class="form-wrap static-form">
        <div id="sign-up-form">
          <h2> Submit your application</h2>
          <form action="#" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
            <div class="app-form-wrap d-flex justify-content-between flex-wrap">
              <div class="box-area">
                <div class="inp-wrap">
                  <div class="inp-fld">
                    <label>Name*</label>
                    <input formControlName="name" type="text" placeholder="John"
                      [ngClass]="{ 'is-invalid': submitted && formData.name.errors }" />
                    <div *ngIf="submitted && formData.name.errors" class="invalid-feedback">
                      <div *ngIf="formData.name.errors.required">Please enter your first name</div>
                    </div>
                  </div>
                </div>
                <div class="inp-wrap">
                  <div class="inp-fld">
                    <label>Email Address*</label>
                    <input type="text" formControlName="email" placeholder="Demo123@example.com"
                      [ngClass]="{ 'is-invalid': submitted && formData.email.errors }" />
                    <div *ngIf="submitted && formData.email.errors" class="invalid-feedback">
                      <div
                        *ngIf="formData.email.errors.required|| formData.email.errors.email || formData.email.errors.emailDomain || formData.email.errors.pattern">
                        Please enter a valid email address</div>
                    </div>
                  </div>
                </div>
                <div class="inp-wrap">
                  <div class="inp-fld">
                    <label>Mobile No*</label>
                    <input maxlength="10"
                      onkeypress='return (event.which > 47 && event.which <= 57) || event.which == 8 || event.which == 46'
                      type="text" formControlName="mobile" placeholder="9876543210"
                      [ngClass]="{ 'is-invalid': submitted && formData.mobile.errors }" />
                    <div *ngIf="submitted && formData.mobile.errors" class="invalid-feedback">
                      <div
                        *ngIf="formData.mobile.errors.required || (formData.mobile.errors.minlength && formData.mobile.errors.maxlength)">
                        Please enter your mobile phone number</div>
                    </div>
                  </div>
                </div>


                <div class="inp-wrap">
                  <div class="inp-fld">
                    <label>Position of Interest</label>
                    <input formControlName="position" type="text" placeholder="Position of interest" />
                  </div>
                </div>
              </div>
              <div class="box-area uploadcv-wrap">
                <div class="text-fld">
                  <label>Tell Us Why You’d Like to Work With Us</label>
                  <textarea formControlName="about"> </textarea>
                </div>
                <div class="img-uploader">
                  <div class="inp-fld">
                    <div class="upload-btn-wrapper">
                      <button class="upl-btn">
                        Resume/CV
                      </button>
                      <input type="file" class="uploader_career" #careerFile name="myfile" (change)="getFile($event)"
                        [ngClass]="{ 'is-invalid': submitted && formData.resume.errors }" />
                      <div *ngIf="submitted && formData.resume.errors" class="invalid-feedback">
                        <div *ngIf="formData.resume.errors.required">Please attach your resume or CV</div>
                      </div>
                      <div class="file-name">
                        {{uploadFileName ? uploadFileName : ''}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="submit-btn text-right">
              <button class="btn">Submit </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="contRes" class="success-msg"> Your Form has been submitted successfully </div>
</section>
<div class="enquiry-poup">
  <app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
  </app-modal-pop-up>
</div>